import Swiper from 'swiper/bundle';

const testimonialSlider = document.querySelectorAll('.testimonials-slider');
const featuredProductsSlider = document.querySelectorAll('.fproducts-slider');
const recentProductsSlider = document.querySelectorAll('.js-resent-product-slider');
const heroSlider = document.querySelectorAll('.js-hero-slider');
const stepsSlider = document.querySelectorAll('.steps-slider');
const isMobile = window.matchMedia("(max-width: 786px)").matches;
const isMobileXs = window.matchMedia("(max-width: 500px)").matches;

function initSlideProduct(slide) {
    const swiper = new Swiper(slide, {
        slidesPerView: 1.5,
        centeredSlides: false,
        spaceBetween: 25,
        loop: false,
        navigation: {
            nextEl: document.querySelector('.swiper-nav__next'),
            prevEl: document.querySelector('.swiper-nav__prev'),
        },
        on: {
            init: function () {
                document.querySelector('.swiper-counter__current').innerHTML = this.realIndex + 1;
                document.querySelector('.swiper-counter__total').innerHTML = this.snapGrid.length;
            },
            slideChange: function () {
                let currentSlide = this.realIndex + 1;
                document.querySelector('.swiper-counter__current').innerHTML = currentSlide;
            }
        },
        breakpoints: {
            650: {
                slidesPerView: 2.5
            },
            998: {
                slidesPerView: 4
            },
            1440: {
                spaceBetween: 32,
                slidesPerView: 4
            }
        }
    });
}

function initSlideRecentProduct(slide) {
    const swiper = new Swiper(slide, {
        slidesPerView: 'auto',
        spaceBetween: 32,
        loop: false,
        navigation: {
            nextEl: slide.closest('.featured-products').querySelector('.swiper-nav__next'),
            prevEl: slide.closest('.featured-products').querySelector('.swiper-nav__prev'),
        },
        breakpoints: {
            650: {
                slidesPerView: 2.75
            },
            993: {
                slidesPerView: 2,
                spaceBetween: 16,
            },

            1200: {
                slidesPerView: 2,
                spaceBetween: 32,
            }
        }
    });
}

function initSlideTestimonial(slide) {
    const swiper = new Swiper(slide, {
        slidesPerView: 1,
        spaceBetween: 15,
        centeredSlides: true,
        loop: true,
        navigation: {
            nextEl: slide.querySelector('.swiper-nav__next'),
            prevEl: slide.querySelector('.swiper-nav__prev')
        },
        on: {
            slideChange: function () {
                let currentSlide = this.realIndex + 1;
                slide.querySelector('.swiper-counter__current').innerHTML = currentSlide;
            },
            beforeInit: function () {
                let numOfSlides = this.wrapperEl.querySelectorAll('.swiper-slide').length;
                slide.querySelector('.swiper-counter__total').innerHTML = numOfSlides;
            }
        },
        breakpoints: {
            560: {
                slidesPerView: 'auto',
                spaceBetween: 32
            }
        }
    });
}

function backgroundSequence(dataset, containerClass, position) {
    const $containerVideo = $('.hero__video video');
    const containerDiv = document.getElementsByClassName(containerClass)[0]
    const videoTag = $containerVideo.get(0)
    const videoMobileSource = dataset.videoMobile ? dataset.videoMobile : dataset.video

    console.log(dataset.type)

    if ('video' === dataset.type) {
        $containerVideo.show();
        $containerVideo.find('source').attr('src', isMobile ? videoMobileSource : dataset.video);
        videoTag.load();

        containerDiv.style.backgroundImage = "none";
        containerDiv.style.backgroundPosition = '';
        return;
    } else if ('image' === dataset.type) {
        $containerVideo.hide();
        $containerVideo.find('source').attr('src', '');
    }

    const image = isMobileXs && dataset.imgMobile.length > 0 ? dataset.imgMobile : dataset.img;

    if (!position) {
        position = 'center center'
    }

    containerDiv.style.backgroundImage = "url(" + image + ")";
    containerDiv.style.backgroundPosition = position;

}

if (testimonialSlider.length) {
    [...testimonialSlider].forEach(slider => {
        initSlideTestimonial(slider)
    });
}

if (featuredProductsSlider.length) {
    [...featuredProductsSlider].forEach(slider => {
        initSlideProduct(slider)
    });
}

if (recentProductsSlider.length) {
    [...recentProductsSlider].forEach(slider => {
        initSlideRecentProduct(slider)
    });
}

if (heroSlider.length) {
    const slide = heroSlider[0]
    let options = {
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: false,
        loop: true,
        navigation: {
            nextEl: document.getElementsByClassName('btn-hero-next')[0],
            prevEl: document.getElementsByClassName('btn-hero-previous')[0]
        },
        on: {
            beforeSlideChangeStart: function (){
                document.querySelector('.hero-overlay').style.backgroundImage = 'none';
            },
            slideChange: function () {
                const currentSlide = this.realIndex + 1;
                let heroCurrentSlide = document.getElementsByClassName('hero-current-slide');
                if (heroCurrentSlide.length > 0) {
                    heroCurrentSlide[0].innerHTML = currentSlide;
                }

                backgroundSequence(this.slides[currentSlide].dataset, 'hero-overlay', (isMobile ? this.slides[currentSlide].dataset.mobile : this.slides[currentSlide].dataset.desktop));
            },
            beforeInit: function () {
                const slides = this.wrapperEl.querySelectorAll('.swiper-slide');
                let numOfSlides = slides.length;
                let heroTotalSlide = document.getElementsByClassName('hero-total-slide');
                if (heroTotalSlide.length > 0) {
                    heroTotalSlide[0].innerHTML = numOfSlides;
                }
                //preload the images for carousel
                for (let i = 0; i < numOfSlides; i++) {
                    // console.log(slides[i].dataset.img)
                    new Image().src = slides[i].dataset.img;
                }

                backgroundSequence(slides[0].dataset, 'hero-overlay', (isMobile ? slides[0].dataset.mobile : slides[0].dataset.desktop));
            }
        },
        // breakpoints: {
        //     560: {
        //         slidesPerView: 'auto',
        //         spaceBetween: 32
        //     }
        // }
    };

    if (1 === parseInt(slide.getAttribute('auto-play'))) {
        options.autoplay = {
            delay: 7000,
            disableOnInteraction: false,
        }
    }

    new Swiper(slide, options);
}

// new Swiper(".single-product-thumbnails", {
//     spaceBetween: 9,
//     slidesPerView: 3,
//     direction: "horizontal",
//     pagination: {
//         el: ".swiper-pagination",
//         dynamicBullets: true,
//         clickable: true,
//     },
//     breakpoints: {
//         0: {
//             spaceBetween: 16
//         },
//         481: {
//             spaceBetween: 24
//         }
//     }
// });

var swiper = new Swiper(".mySwiper", {
    spaceBetween: 10,
    slidesPerView: 3,
    centeredSlides: true,
    freeMode: true,
    loop: true,
    watchSlidesProgress: true,
    pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
        clickable: true
    }
});
var swiper2 = new Swiper(".mySwiper2", {
    spaceBetween: 10,
    loop: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    },
    thumbs: {
        swiper: swiper
    },
});

const mySwiper2 = document.querySelector('.mySwiper2');

if (mySwiper2) {
    document.querySelector('.mySwiper2 .swiper-button-next').addEventListener('click', function () {
        swiper.slideNext();
    });

    document.querySelector('.mySwiper2 .swiper-button-prev').addEventListener('click', function () {
        swiper.slidePrev();
    });
}

if (isMobile && stepsSlider.length) {
    [...stepsSlider].forEach(slider => {
        initSlideTestimonial(slider)
    });
}

// $('.single-product-thumbnails .swiper-slide-active').addClass('current-item');
// $('.single-product-thumbnails .swiper-slide a').click(function H(e) {
//     e.preventDefault();
//     $(this).parent().toggleClass('current-item');
//     $(this).parent().siblings()
//         .removeClass('current-item');
//
//     let imgPath = $(this).find('img').attr('src');
//     $('.js-product-img img').attr("src", imgPath).removeAttr('srcset').removeAttr('sizes');
// });

/**
 * Slider MW Testimonials
 */

document.querySelectorAll('.swiper-mw-testimonials').forEach(slider => {
    const wrapper = slider.closest('.mw-testimonials__slider-controls');
    new Swiper(slider, {
        slidesPerView: 1,
        loop: true,
        pagination: false,
        navigation: {
            nextEl: wrapper.querySelector('.swiper-button-next'),
            prevEl: wrapper.querySelector('.swiper-button-prev')
        }
    });

});
